import { render } from "./StatsWidgetMenuConfig.vue?vue&type=template&id=814d7b42"
import script from "./StatsWidgetMenuConfig.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetMenuConfig.vue?vue&type=script&lang=ts"
script.render = render

export default script